<template>
  <div>
    <v-app-bar color="red" dark outlined app>
      <v-toolbar-title>Menu</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="loadCart" :disabled="!itemInCart">
        <v-badge
          color="black"
          :content="itemInCart"
          :value="itemInCart"
          overlap
        >
          <v-icon>mdi-cart</v-icon>
        </v-badge>
      </v-btn>
    </v-app-bar>

    <v-main>
      <!-- Skeleton -->
      <div v-if="isMenuLoading">
        <v-skeleton-loader
          class="mx-auto"
          type="list-item-two-line"
          v-for="i in 3"
          :key="i"
        />
      </div>

      <!-- Menu list -->
      <v-list flat v-else>
        <v-list-item
          v-for="item in menu"
          :key="item.id"
          two-line
          @click="showMenu(item)"
          class="list-border"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>

            <v-list-item-subtitle class="text-right">
              <strong class="green--text">{{
                item.amount ? `${item.amount} x ` : ""
              }}</strong>
              Rp. {{ formatCurrency(item.price) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- Add to cart -->
      <v-dialog
        id="add-to-cart"
        v-model="showTempCart"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="red">
            <v-toolbar-title>Tambah ke Keranjang</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-title class="align-center">{{ tempCart.name }}</v-card-title>
          <v-card-text>
            <p>Rp. {{ formatCurrency(tempCart.price) }}</p>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="tempCart.amount"
                  :append-outer-icon="'mdi-plus'"
                  :prepend-icon="'mdi-minus'"
                  type="number"
                  @click:append-outer="changeAmount(1)"
                  @click:prepend="changeAmount(-1)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="red"
              :dark="!isNegativeAmount"
              block
              @click="showTempCart = false"
              :disabled="isNegativeAmount"
            >
              {{ tempCart.amount === 0 ? "Batal" : "Tambah" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Cart -->
      <v-dialog id="cart" v-model="showCart" fullscreen>
        <v-card>
          <v-toolbar dark color="red">
            <v-toolbar-title>Keranjang</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="showCart = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list flat>
            <v-list-item v-for="item in cart" :key="item.id" two-line>
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle class="text-right"
                  >{{ item.amount }} x Rp.
                  {{ formatCurrency(item.price) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>
          <div class="text-right text-h6" style="padding-right: 12px">
            Rp. {{ formatCurrency(totalPrice) }}
          </div>
          <v-card-actions>
            <v-btn
              color="red"
              block
              @click="createTransaction"
              :dark="totalPrice !== 0"
              :disabled="totalPrice === 0"
              :loading="isLoading"
              >Pesan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Overlay -->
      <v-overlay :value="isLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <!-- Snackbar -->
      <v-snackbar v-model="showSnackbar" multi-line bottom
        >{{ textSnackbar }}
      </v-snackbar>
    </v-main>
  </div>
</template>

<script>
import EzKasirAPI from "@/library/api";
import common from "@/mixins/common";
import store from "@/store";

export default {
  name: "Menu",
  mixins: [common],
  data() {
    return {
      user: null,
      isMenuLoading: true,
      showTempCart: false,
      tempCart: {},
      showCart: false,
      cart: [],
      totalPrice: 0,
      menu: [],
      isLoading: false,
      textSnackbar: "",
      showSnackbar: false,
      itemInCart: 0,
    };
  },
  methods: {
    loadMenu() {
      const url = `${process.env.VUE_APP_API_URL}/store/menu/${this.user.store.id}`;
      EzKasirAPI.get(url)
        .then((response) => {
          this.menu = response.data.data;
        })
        .finally(() => {
          this.isMenuLoading = false;
        });
    },
    showMenu(item) {
      this.tempCart = item;
      this.showTempCart = true;
    },
    changeAmount(x) {
      if (x === -1 && this.tempCart.amount === 0) {
        return null;
      }
      this.tempCart.amount = parseInt(this.tempCart.amount) + parseInt(x);
      this.itemInCart += x;
    },
    loadCart() {
      this.totalPrice = 0;
      this.cart = [];
      this.showCart = true;
      this.menu.forEach((item) => {
        if (item.amount > 0) {
          this.totalPrice += item.price * item.amount;
          this.cart.push(item);
        }
      });
    },
    addToCart() {
      this.showTempCart = false;
    },
    createTransaction() {
      this.isLoading = true;
      let req = [];
      this.cart.forEach((item) => {
        req.push({
          id: item.id,
          amount: item.amount,
        });
      });

      const url = `${process.env.VUE_APP_API_URL}/transaction/${this.user.store_id}`;
      EzKasirAPI.post(url, {
        items: req,
      })
        .then(() => {
          this.textSnackbar = "Berhasil membuat pesanan";
        })
        .catch((error) => {
          console.error(error);
          this.textSnackbar = "Gagal membuat pesanan";
        })
        .finally(() => {
          this.showCart = false;
          this.isLoading = false;
          this.showSnackbar = true;
          this.itemInCart = 0;
          this.loadMenu();
        });
    },
  },
  created() {
    this.user = store.state.user;
    if (this.user) {
      EzKasirAPI.defaults.headers.common = {
        Authorization: `Bearer ${this.user.token}`,
      };
      this.loadMenu();
    }
  },
  computed: {
    isNegativeAmount() {
      return this.tempCart.amount < 0;
    },
  },
};
</script>

<style scoped>
.list-border {
  border-bottom: 1px solid lightgray;
}
</style>
